import React, { Fragment, useCallback, useState } from 'react'
import { InputError } from '@foodsby/nutrient'
import { useDropzone } from 'react-dropzone'
import cn from 'classnames'
import { validProfileImage } from '../../util/validators'
import { Intials } from '../community/FriendLabel'

export const ProfileAvatar = ({ className, src, size, name }) => {
  return (
    <div className={className}>
      {src ? (
        <img alt="" height={size} src={src} width={size} />
      ) : name ? (
        <div className="no-profile-img">{Intials(name)}</div>
      ) : (
        <img
          alt=""
          height={size}
          src="https://images.foodsby.com/conweb/profile-placeholder.png"
        />
      )}
    </div>
  )
}

export const ProfileImage = ({
  avatarId,
  updateProfilePictureStart,
  updateProfilePictureLoading,
  name,
  isWebpSupported,
}) => {
  const [validationError, setValidationError] = useState(undefined)

  const onDrop = useCallback(
    acceptedFiles => {
      const img = acceptedFiles[0]
      if (img) {
        const errors = validProfileImage(img)
        if (errors) {
          setValidationError(errors)
        } else if (img) {
          setValidationError(undefined)
          updateProfilePictureStart(img)
        }
      }
    },
    [updateProfilePictureStart],
  )

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop })

  const imgSrc =
    avatarId && isWebpSupported !== undefined
      ? `${process.env.REACT_APP_IMAGE_LAMBDA}/profiles/${avatarId}.${
          isWebpSupported ? 'webp' : 'jpg'
        }?height=150&width=150`
      : ''

  return (
    <Fragment>
      <div className="edit_profile_img_action" {...getRootProps()}>
        <input
          {...getInputProps()}
          data-cy="dropzone"
          disabled={updateProfilePictureLoading}
        />
        <ProfileAvatar
          className={cn({
            'profile-image': true,
            'drag-active': isDragActive,
            loading: updateProfilePictureLoading,
          })}
          name={name}
          size={120}
          src={imgSrc}
        />
      </div>
      {validationError && <InputError>{validationError}</InputError>}
    </Fragment>
  )
}
